// 404一类页面
export default [
  {
    path: '/404',
    name: 'notFound',
    component: () =>
    import(/* webpackChunkName: "Index" */ '@/components/not-found/404')
  },
  // 此处需特别注意置于最底部
  {
    path: '*',
    redirect: '/404'
  }
]



// WEBPACK FOOTER //
// ./src/router/router-child/not-found.js